import { push } from 'react-router-redux';
import { takeEvery } from 'redux-saga';
import { put, call, select, fork } from 'redux-saga/effects';
import otcEntry from '@tcc/otc-entry';

import { REDIRECT_USER } from 'constants/actionTypes';
import { emailVerification } from 'constants/statuses';
import { getFieldsRequest } from 'requesters/loginRequester';
import { isDealerUser } from 'utils/user';

/**
 * Check for fields API call and redirect.
 * On success, if field length is 0, redirect to MFS, otherwise redirect to dashboard
 * On failure, default redirect to dashboard
 * @param {String} userId
 * @return {void}
 */
export function *getFieldsAndRedirect(userId) {
  try {
    const response = yield call(getFieldsRequest, userId);
    if (response.fields && response.fields.length === 0) {
      // If user has no fields, redirect to MFS
      document.location.assign('/static/mfs/index.html');
      return;
    }
  } finally {
    // By default, redirect to dashboard
    const userIdParam = userId ? `?client-id=${userId}` : '';
    document.location.assign(`/static/dashboard/index.html${userIdParam}#dashboard-map`);
  }
}

/**
 * Redirect logic
 * @param {object} user
 * @return {void}
 */
export function *redirectUser() {
  const {
    user,
    redirection: {
      redirectTo
    },
    verification: {
      verificationToken
    }
  } = yield select();

  // If we have an stored verification token, redirect to the verification page
  if (verificationToken) {
    yield put(push(`/verification`));
    return;
  }
  // If the user has to be redirected to an specific page
  if (redirectTo) {
    document.location.assign(redirectTo);
    return;
  }
  // If user is not verified, redirect to verification
  if (user.emailVerificationStatus === emailVerification.UNVERIFIED) {
    yield put(push(`/verification/sent`));
    return;
  }
  // If user has a dealer role, redirect to dealer-portal
  if (isDealerUser(user)) {
    document.location.assign(otcEntry.getDealerPortalUrl());
    return;
  }

  yield call(getFieldsAndRedirect, user.id);
}

/**
 * Redirect current user
 * @return {void}
 */
export function *redirectUserWatcher() {
  yield* takeEvery(REDIRECT_USER, redirectUser);
}

/**
 * Uses fork to start multiple watchers in parallel
 * @return {void}
 */
export default function *rootSaga() {
  yield fork(redirectUserWatcher);
}